import React from 'react';
import { Phone, MapPin, Clock, ChevronDown, Facebook, Instagram } from 'lucide-react';
import { RESTAURANT, IMAGES } from '../mock';

export default function Hero() {
  return (
    <section id="top" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={IMAGES.hero}
          alt="Warmes Interieur des Restaurant Alfa mit Natursteinwänden"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 hero-vignette" />
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto pt-24 pb-32">
        <div className="flex items-center justify-center gap-4 mb-8">
          <span className="hidden sm:block h-px w-10 bg-[rgba(224,180,159,0.5)]" />
          <span className="eyebrow">Griechisches Restaurant · Heideck</span>
          <span className="hidden sm:block h-px w-10 bg-[rgba(224,180,159,0.5)]" />
        </div>

        <h1 className="font-serif-display font-medium text-[#f6f0e9] leading-[0.98] text-[15vw] sm:text-7xl md:text-8xl lg:text-[8.5rem]">
          Ein Stück
          <br />
          <span className="italic text-[#e0b49f]">Hellas,</span>
          <br />
          mitten in Heideck.
        </h1>

        <p className="mt-8 text-[#d6ccc1] text-lg md:text-xl max-w-xl mx-auto font-light leading-relaxed">
          Mediterrane Küche, warmer Naturstein und griechische Gastfreundschaft – seit 28. November 2025 in der Hauptstraße 9.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={RESTAURANT.phoneHref}
            className="group flex items-center gap-2.5 bg-[#e0b49f] text-[#1a1410] px-8 py-4 rounded-full font-medium tracking-wide hover:bg-[#eac6b3] transition-all duration-300 shadow-lg shadow-black/30"
          >
            <Phone size={17} className="group-hover:rotate-12 transition-transform duration-300" />
            Tisch reservieren
          </a>
          <a
            href="#speisekarte"
            className="flex items-center gap-2 border border-[rgba(242,235,227,0.4)] text-[#f2ebe3] px-8 py-4 rounded-full font-medium tracking-wide hover:border-[#e0b49f] hover:text-[#e0b49f] transition-all duration-300"
          >
            Speisekarte entdecken
          </a>
        </div>

        <a
          href={RESTAURANT.facebook}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-5 inline-flex items-center gap-2 text-[#d6ccc1] text-sm hover:text-[#e0b49f] transition-colors duration-300"
        >
          <Facebook size={15} /> oder bequem über Facebook reservieren
        </a>

        <div className="mt-4 flex items-center justify-center gap-4">
          <a
            href={RESTAURANT.facebook}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
            className="flex items-center justify-center h-10 w-10 rounded-full border border-[rgba(242,235,227,0.3)] text-[#f2ebe3] hover:bg-[#e0b49f] hover:text-[#1a1410] hover:border-[#e0b49f] transition-all duration-300"
          >
            <Facebook size={17} />
          </a>
          <a
            href={RESTAURANT.instagram}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="flex items-center justify-center h-10 w-10 rounded-full border border-[rgba(242,235,227,0.3)] text-[#f2ebe3] hover:bg-[#e0b49f] hover:text-[#1a1410] hover:border-[#e0b49f] transition-all duration-300"
          >
            <Instagram size={17} />
          </a>
        </div>
      </div>

      {/* Bottom info bar */}
      <div className="absolute bottom-0 left-0 right-0 z-10 border-t border-[rgba(242,235,227,0.12)] bg-[#100d0b]/40 backdrop-blur-sm">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-4 flex flex-col sm:flex-row items-center justify-between gap-3 text-[#d6ccc1]">
          <div className="flex items-center gap-2.5 text-sm tracking-wide">
            <MapPin size={15} className="text-[#e0b49f]" />
            <span className="uppercase tracking-[0.14em] text-xs">{RESTAURANT.address}</span>
          </div>
          <div className="hidden sm:flex items-center gap-2.5 text-sm">
            <Clock size={15} className="text-[#e0b49f]" />
            <span className="uppercase tracking-[0.14em] text-xs">{RESTAURANT.todayNote}</span>
          </div>
          <a href="#willkommen" className="flex items-center gap-2 text-xs uppercase tracking-[0.14em] hover:text-[#e0b49f] transition-colors">
            Entdecken
            <ChevronDown size={15} className="animate-bounce" />
          </a>
        </div>
      </div>
    </section>
  );
}
